import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}


  var reformatEmployee = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.employee_nip+" - "+region.employee_name;
      newObj["value"] = region.employee_uuid;
      newObj["model"] = region;
      return newObj;
    });
};
  
  var reformatType = function(regions) {
    return regions.map(function(region) {
      var newObj = {};
      newObj["label"] = region.retired_type_name;
      newObj["value"] = region.retired_type_uuid;
      return newObj;
    });
  };


class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                nip: "",
                nama: "",
                unit_kerja: "",
                jabatan: "",
                tmt_jabatan: "",
                tgl_pensiun:"",
                golongan: "",
                tgl_lahir: "",
                jenis_kelamin: "",
                tmt_pensiun: "",
                usia: "",
                usia_pensiun: "",
                sisa_masa_kerja:""
            },
            employeeItems: [],
            employeeSelected: "",
            typeItems:[],
            typeSelected:""
        }
    }

    submitData = async () => {
        if(this.state.dataForm.document.length > 0){
            let formData = generateFormData(this.state.dataForm, 'document') 
            await this.createBloc.fetchCreate(formData)
        }else{
            await this.createBloc.fetchCreate(this.state.dataForm)
        }      
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    onChangeEmployee = (employee) => {
        var model = employee.model
        this.setState({
            employeeSelected: employee.value,
            dataForm: {
                nip: model.employee_nip,
                nama: model.employee_name,
                unit_kerja: model.employee_current_work_unit_name,
                jabatan: model.employee_current_position_name,
                tmt_jabatan: model.employee_current_tmt_position,
                tgl_pensiun: model.employee_date_of_pension,
                golongan: model.employee_current_rank_group_code,
                tgl_lahir: model.employee_date_of_birth,
                jenis_kelamin: model.gender_name,
                tmt_pensiun: model.employee_tmt_pension,
                usia: model.employee_age,
                usia_pensiun: model.employee_age_retired,
                sisa_masa_kerja: model.employee_work_age
            }
        })
    }
    
    onChangeTypeSelected = (type) => {
        this.setState({
            typeSelected: type.value,
        });
    }   

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

         this.createBloc.employeeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            employeeItems: reformatEmployee(response.result),
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
         })
        
        this.createBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            typeItems: reformatType(response.result)
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        this.createBloc.employeeSelfChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                         let response = result.data.response
                         
                        //  console.log(model)

                        if (response.result !== null) {
                            let model = response.result
                            this.setState({
                                employeeSelected: model.employee_uuid,
                                dataForm: {
                                    nip: model.employee_nip,
                                    nama: model.employee_name,
                                    unit_kerja: model.employee_current_work_unit_name,
                                    jabatan: model.employee_current_position_name,
                                    tmt_jabatan: model.employee_current_tmt_position,
                                    tgl_pensiun: model.employee_date_of_pension,
                                    golongan: model.employee_current_rank_group_code,
                                    tgl_lahir: model.employee_date_of_birth,
                                    jenis_kelamin: model.gender_name,
                                    tmt_pensiun: model.employee_tmt_pension,
                                    usia: model.employee_age,
                                    usia_pensiun: model.employee_age_retired,
                                    sisa_masa_kerja: model.employee_work_age
                                }
                            })
                        }

                        
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        
        
        this.createBloc.fetchEmployee()
        this.createBloc.fetchType()
        this.createBloc.fetchEmployeeSelf({
            "employee_uuid": peg_uuid
        })
      
      
        
    }

 

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Pensiun</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <AvField
                                            name="retired_employee_uuid"
                                            type="hidden"
                                            className="form-control"
                                            validate={{ required: { value: true } }}
                                            id="retired_employee_uuid"
                                            value={this.state.employeeSelected}
                                        />
                                        
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            NIP 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="nip"
                                                    id="nip"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nip}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Nama 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="nama"
                                                    id="nama"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.nama}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Unit Kerja
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="unit_kerja"
                                                    id="unit_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.unit_kerja}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jabatan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jabatan"
                                                    id="jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Jabatan 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_jabatan"
                                                    id="tmt_jabatan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_jabatan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Golongan 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="golongan"
                                                    id="golongan"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.golongan}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Lahir 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_lahir"
                                                    id="tgl_lahir"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_lahir}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis Kelamin 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="jenis_kelamin"
                                                    id="jenis_kelamin"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.jenis_kelamin}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Tanggal Pensiun 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="tgl_pensiun"
                                                    id="tgl_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tgl_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TMT Pensiun 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="tmt_pensiun"
                                                    id="tmt_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.tmt_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                       

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia 
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    placeholder=""
                                                    name="usia"
                                                    id="usia"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia}
                                                />
                                            </Col>
                                        </Row>

                                          <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Usia Pensiun
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="usia_pensiun"
                                                    id="usia_pensiun"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.usia_pensiun}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Sisa Masa Kerja 
                                            </label>
                                            <Col md="9">
                                                <AvField
                                                    placeholder=""
                                                    name="sisa_masa_kerja"
                                                    id="sisa_masa_kerja"
                                                    readonly="readonly"
                                                    type="form-control"
                                                    className="form-control"
                                                    value={this.state.dataForm.sisa_masa_kerja}
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Jenis <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <Select
                                                    value={this.state.typeItems.filter(option => 
                                                      option.value === this.state.typeSelected)}
                                                    onChange={
                                                      this.onChangeTypeSelected
                                                    }
                                                    required="required"
                                                    options={this.state.typeItems}
                                                    classNamePrefix=""
                                                    placeholder="Pilih Jenis"
                                                />
                                                <AvField
                                                    name="retired_employee_retired_type_uuid"
                                                    type="hidden"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="retired_employee_retired_type_uuid"
                                                    value={this.state.typeSelected}
                                                />
                                            </Col>
                                        </Row>


                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            TUSK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="tusk"
                                                    id="tusk"
                                                    placeholder="TUSK"
                                                    type="text"
                                                    errorMessage="TUSK"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        
                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            MPP <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                 <AvField
                                                    name="mpp"
                                                    id="mpp"
                                                    placeholder="MPP"
                                                    type="text"
                                                    errorMessage="MPP"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            File SK <span className="text-danger">*</span>
                                            </label>
                                            <Col md="5">
                                                <FileInput 
                                                    name="document"
                                                />
                                            </Col>
                                        </Row>

                                       
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?pensiunpegawai">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?pensiunpegawai'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView